import { render, staticRenderFns } from "./createuser.vue?vue&type=template&id=5c545a22&"
import script from "./createuser.vue?vue&type=script&lang=js&"
export * from "./createuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports